import NSelection from '@/views/n-selection/NSelection'
import SelectProducts from '@/views/n-selection/SelectProducts'
import Discount from '@/views/n-selection/Discount'
import DetailInformation from '@/views/n-selection/DetailInformation'
import Confirm from '@/views/n-selection/Confirm'
import Complete from '@/views/n-selection/Complete'

export default {
  path: '/n-selection',
  component: NSelection,
  children: [
    {
      path: 'selectProducts',
      name: 'NSelectionSelectProducts',
      component: SelectProducts
    },
    {
      path: 'discount',
      name: 'NSelectionDiscount',
      component: Discount
    },
    {
      path: 'selectPaymentAndShipping',
      name: 'NSelectionSelectPaymentAndShipping',
      component: DetailInformation
    },
    {
      path: 'confirm',
      name: 'NSelectionConfirm',
      component: Confirm,
      props: true
    },
    {
      path: 'complete',
      name: 'NSelectionComplete',
      component: Complete,
      props: true
    },
  ]
}

// ��製tep1: n-selection/selectProducts
// ��製tep2: n-selection/discount
// ��製tep3: n-selection/selectPayment
// ��製tep4: n-selection/confirm, complete



// WEBPACK FOOTER //
// ./src/router/n-selection/index.js